import { createSlice } from '@reduxjs/toolkit';

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: {
    expandedReplies: false,
    bigThumbnails: false,
    values: {},
  },
  reducers: {
    setExpandedReplies(state, action) {
      state.expandedReplies = action.payload;
    },
    toggleExpandedReplies(state) {
      state.expandedReplies = !state.expandedReplies;
    },
    setBigThumbnails(state, action) {
      state.bigThumbnails = action.payload;
    },
    toggleBigThumbnails(state) {
      state.bigThumbnails = !state.bigThumbnails;
    },
    setPreferences(state, action) {
      state.values = action.payload;
    },
  },
});

export const {
  setBigThumbnails,
  setExpandedReplies,
  setPreferences,
  toggleBigThumbnails,
  toggleExpandedReplies,
} = preferencesSlice.actions;

export const selectExpandedReplies = state => state.preferences.expandedReplies;
export const selectBigThumbnails = state => state.preferences.bigThumbnails;
export const selectPreferences = state => state.preferences.values;

export default preferencesSlice.reducer;
